module.exports = __webpack_public_path__ + "zvetseni-prsou_29_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_29_before.jpg
// module id = 1322
// module chunks = 0